import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import { ResponseError } from '@backstage/errors';
import type {
  ContextRouterApi,
  ContextStatusResponse,
  ContextCacheJob,
  JobLogsResponse,
} from './types';

export class ContextRouterClient implements ContextRouterApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async baseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('context');
  }

  private async fetch<T>(path: string, init?: RequestInit): Promise<T> {
    const url = `${await this.baseUrl()}${path}`;
    const res = await this.fetchApi.fetch(url, init);
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    return res.json() as Promise<T>;
  }

  async getRebuildStatus(): Promise<ContextCacheJob | null> {
    return this.fetch('/admin/rebuild');
  }

  async getJobStatus(jobId: string): Promise<ContextCacheJob> {
    return this.fetch(`/admin/jobs/${encodeURIComponent(jobId)}`);
  }

  async getJobLogs(jobId: string): Promise<JobLogsResponse> {
    return this.fetch(`/admin/jobs/${encodeURIComponent(jobId)}/logs`);
  }

  async triggerRebuild(): Promise<ContextCacheJob> {
    return this.fetch('/admin/rebuild', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ mode: 'seed' }),
    });
  }

  async getStatus(): Promise<ContextStatusResponse> {
    return this.fetch('/status');
  }
}
